
import { defineComponent } from "vue";
import initSqlJs from "sql.js";
import { mapStores } from "pinia";
import { useMainStore } from "@/store";
// Required to let webpack 4 know it needs to copy the wasm file to our assets
import sqlWasm from "!!file-loader?name=sql-wasm-[contenthash].wasm!sql.js/dist/sql-wasm.wasm";

export default defineComponent({
  name: "Advanced",
  async created() {
    if (!this.mainStore.sortedMessages) {
      this.goToHome();
    }
    const SQL = await initSqlJs({ locateFile: () => sqlWasm });
    this.db = new SQL.Database();
  },
  data() {
    return {
      nRows: 0,
      loaded: false,
      loading: false,
      SQLQuery: "",
      result: "",
      error: null,
      db: null,
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    goToHome() {
      this.$router.push("/");
    },
    runQuery() {
      this.result = null;
      try {
        this.result = this.db.exec(this.SQLQuery)[0];
      } catch (error) {
        this.error = error;
        console.log(error);
      }
    },
    async startLoad() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.db.run(
        "CREATE TABLE messages (conversationName TEXT, conversationId TEXT, conversationType TEXT," +
          "timestampMs INTEGER, sender TEXT, text TEXT, photos TEXT, reactions TEXT);"
      );
      this.mainStore.sortedMessages.forEach((msg) => {
        let insertStmt = `INSERT INTO messages (conversationName, conversationId, conversationType, timestampMs, sender, text, photos, reactions)
                            VALUES (?, ?, ?, ?, ?, ?, ?, ?)`;
        let binding = [
          msg.conversationName,
          msg.conversationId,
          msg.conversationType,
          msg.timestamp,
          msg.sender,
          msg.text ? msg.text : "",
          JSON.stringify(msg.photos),
          msg.reactions ? JSON.stringify(msg.reactions) : null,
        ];
        this.db.run(insertStmt, binding);
        this.nRows += 1;
        console.log(this.nRows);
      });
      this.loaded = true;
      this.loading = false;
    },
  },
});
